export function sessionStorageSet(key, value) {
  window.sessionStorage.setItem(key, JSON.stringify(value));
}

export function sessionStorageGet(key) {
  try {
    return JSON.parse(window.sessionStorage.getItem(key));
  } catch (e) {
    return undefined;
  }
}

export function sessionStorageRemove(key) {
  window.sessionStorage.removeItem(key);
}
